import React, { useState } from "react";
import { LogInIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import { apiPost } from "../../utils/api";
import { showError, showSuccess } from "../../utils/alert";
import { useDispatch } from "react-redux";
import { loginStore } from "../../redux/storeSlice";
import { Store } from "../../types/modules/store.type";
import { getdeviceId } from "../../utils/auth";

interface Props {
  storeId: number;
}

const SelectStoreButton: React.FC<Props> = ({ storeId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading,setLoading] = useState(false);
  const {accessToken} = useSelector((s:RootState)=>s.owner);
  

   const handleSelect = async () => {
      try {
          setLoading(true);
          const deviceId = getdeviceId();
        const response = await apiPost(`store/${storeId}/select/byOwner`,{deviceId},{Authorization:accessToken}) as{accessToken:string,refreshToken:string,store:Store};
        const message =t("store_selected_success");
        showSuccess(message);
        dispatch(loginStore({accessToken:response.accessToken,refreshToken:response.refreshToken,store:response.store}))
        setLoading(false);
      } catch (err: any) {
          setLoading(false);
          showError(err.message)
      }
    };

  return (
    <>
      <button
        onClick={handleSelect}
        disabled={loading}
        className="flex items-center gap-1 px-3 py-2 bg-white text-primary rounded-full shadow disabled:opacity-50"
      >
        <LogInIcon size={18} />
        <span className="text-sm font-medium">{t("select")}</span>
      </button>

      {/* Overlay */}
      {loading && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
    </>
  );
};

export default SelectStoreButton;
